<template>
  <div class="case">
    <OtheHeader />
    <div class="content">
      <div class="breadcrumb">
        <img src="../assets/img/fangzi.png" alt style="width:16px;height:15px;margin-right:18px" />
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <router-link to="/">
              首页
            </router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>行业/案例</el-breadcrumb-item>
          <el-breadcrumb-item>{{classActiveName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="heade">
        <div class="heade-item" v-for="(item, index) in classList" :key="item.id" @click="chooseClass(item)">
          <div :class="{'headeLine': classActive != item.id}">
            <div :class="{'heade-active': classActive == item.id}">
              <!-- <p class="el-icon-mobile-phone" style="font-size: 30px;"></p> -->
              <img :src="imgList[classActive == item.id ? index + 10 : index]" alt="" style="height: 40px;">
              <p class="heade-txt">{{item.name}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="title">
        <p class="title-ch">行业/案例</p>
        <p class="title-en">Industry/Case</p>
      </div>
      <div class="list">
        <div class="list-item" v-for="item in showList.list" :key="item.id">
          <router-link :to="{name: 'CaseDetail', query: {id: item.id }}" target="_blank" style="display: flex;">
            <div class="list-img">
              <img
                :src="'http://develop.line-found.com/' + item.image"
                alt
                style="width:100%;height:100%;"
              />
            </div>
            <div class="list-body">
              <div>
                <p class="body-title">{{item.name}}</p>
                <p
                  class="body-date"
                >{{new Date(parseInt(item.createtime) * 1000).toLocaleString().split(' ')[0].replace('/', '-').replace('/', '-')}}</p>
                <p class="body-txt" v-html="item.content"></p>
              </div>
              <el-button class="body-btn">查看详情</el-button>
            </div>
          </router-link>
        </div>
      </div>
      <div class="pagination">
        <p>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="4"
            :total="showList.page.total"
            :current-page="pageNo"
            @current-change="handleCurrentPageChange"
          ></el-pagination>
        </p>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import OtheHeader from "@/components/OtheHeader.vue";
import Footer from "@/components/Footer.vue";

// import { formatTime } from '@/utils/util'

export default {
  name: "Case",
  components: {
    OtheHeader,
    Footer
  },
  data() {
    return {
      classActive: 2,
      classActiveName: "",
      classList: [],
      pageNo: 1,
      showList: {
        list: [],
        page: {
          total: 1
        }
      },
      imgList: [
        require('../assets/img/hy1.png'),
        require('../assets/img/hy2.png'),
        require('../assets/img/hy3.png'),
        require('../assets/img/hy4.png'),
        require('../assets/img/hy5.png'),
        require('../assets/img/hy6.png'),
        require('../assets/img/hy7.png'),
        require('../assets/img/hy8.png'),
        require('../assets/img/hy9.png'),
        require('../assets/img/hy10.png'),
        require('../assets/img/hya1.png'),
        require('../assets/img/hya2.png'),
        require('../assets/img/hya3.png'),
        require('../assets/img/hya4.png'),
        require('../assets/img/hya5.png'),
        require('../assets/img/hya6.png'),
        require('../assets/img/hya7.png'),
        require('../assets/img/hya8.png'),
        require('../assets/img/hya9.png'),
        require('../assets/img/hya10.png'),
      ]
    };
  },
  created() {
    this.getProductClass();
  },
  methods: {
    chooseClass(item) {
      this.classActive = item.id;
      this.classActiveName = item.name;
      this.pageNo = 1;
      this.getProductList();
    },
    handleCurrentPageChange(selectedPageSize) {
      this.pageNo = selectedPageSize;
      this.getProductList();
    },
    getProductClass() {
      this.fetchGet("index/getCasesType")
        .then(res => {
          this.classList = res.data;
          this.classActive = res.data[0].id;
          this.classActiveName = res.data[0].name;
          this.getProductList();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getProductList() {
      this.fetchGet("index/getCasesList", {
        type: this.classActive,
        listRows: 4,
        p: this.pageNo
      })
        .then(res => {
          if (res.code == 1) {
            this.showList = res.data;
          } else {
            this.showList = {
              list: [],
              page: {
                total: 1
              }
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style scoped lang="less">
.case {
  .pagination {
    // display: flex;
    margin-bottom: 74px;
    span {
      font-size: 12px;
      color: rgba(100, 100, 100, 1);
      margin-left: 25px;
    }
    p {
      // margin-left: 209px;
      text-align: center;
    }
  }
  .content {
    width: 1197px;
    margin: 0 auto;
    .breadcrumb {
      display: flex;
      margin-top: 30px;
    }
    .heade {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      height: 140px;
      background-color: #ffffff;
      box-shadow: 3px 4px 24px rgba(4, 0, 0, 0.11);
      margin: 50px auto 0;
      .headeLine {
        padding: 10px 0;
        border-left: 1px solid #eeeeee;
      }
      .heade-item {
        width: 133px;
        text-align: center;
        .heade-txt {
          color: #666666;
          font-size: 16px;
          margin-top: 4px;
        }
        .heade-active {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 120px;
          height: 140px;
          color: #ffffff;
          background-color: #66bfe6;
          margin: -30px auto 0;
          .heade-txt {
            color: #ffffff;
            font-size: 16px;
            margin-top: 4px;
          }
        }
      }
      .heade-line {
        height: 66px;
        border-left: 1px solid #f1f1f1;
      }
    }
    .title {
      margin-top: 43px;
      .title-ch {
        color: #3e3e3e;
        font-size: 26px;
        font-weight: bold;
        text-align: center;
      }
      .title-en {
        color: #c7c4c4;
        font-size: 16px;
        text-align: center;
      }
    }
    .list {
      margin-top: 45px;
      padding: 0 32px;
      box-sizing: border-box;
      .list-item {
        display: flex;
        margin-bottom: 36px;
        padding: 27px 34px;
        overflow: hidden;
        .list-img {
          flex-shrink: 0;
          width: 248px;
          height: 165px;
        }
        .list-body {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          height: 165px;
          margin-left: 18px;
          .body-title {
            color: #333333;
            font-size: 18px;
          }
          .body-date {
            color: #999999;
            font-size: 12px;
            margin-top: 4px;
          }
          .body-txt {
            color: #666666;
            font-size: 14px;
            margin-top: 10px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            letter-spacing: 2px;
          }
          .body-btn {
            width: 100px;
            height: 30px;
            color: #999999;
            font-size: 14px;
            border-color: #999999;
            border-radius: 0;
            padding: 0;
          }
        }
      }
      .list-item:hover {
        background-color: #eef0f0;
        cursor: pointer;
      }
      .list-item:hover .body-btn {
        background-color: #00a8eb;
        color: #ffffff;
        border: none;
      }
    }
  }
}
</style>
